import React, { useId, useRef, useState } from 'react';

export function FileUpload({ files = [], onAdd, onRemove, busy, error, maxFiles = 10, maxSizeMB = 10 }) {
  const id = useId();
  const input = useRef(null);
  const [validationError, setValidationError] = useState('');
  const [dragging, setDragging] = useState(false);
  function select(incoming) {
    if (busy) return;
    const chosen = [];
    const errors = [];
    let available = maxFiles - files.length;
    for (const file of incoming) {
      const expectedType = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', pdf: 'application/pdf' }[file.name.split('.').pop().toLowerCase()];
      if (!expectedType || (file.type && file.type !== expectedType)) { errors.push(`${file.name}: choose a JPG, PNG, or PDF.`); continue; }
      if (!file.size || file.size > maxSizeMB * 1024 * 1024) { errors.push(`${file.name}: files must be nonempty and no larger than ${maxSizeMB} MB.`); continue; }
      const prior = files.find(item => item.name === file.name && item.size === file.size);
      if (prior?.status === 'uploaded' || chosen.some(item => item.name === file.name && item.size === file.size)) { errors.push(`${file.name} is already attached.`); continue; }
      if (!prior && available <= 0) { errors.push(`You can attach up to ${maxFiles} files.`); continue; }
      if (!prior) available--;
      chosen.push(file);
    }
    setValidationError(errors.join(' '));
    if (chosen.length) onAdd(chosen);
  }
  return <div>
    <label htmlFor={id} style={{ display: 'block', fontWeight: 600, marginBottom: 8 }}>Equipment photos and documents</label>
    <div onDragOver={event => { event.preventDefault(); setDragging(true); }} onDragLeave={() => setDragging(false)}
      onDrop={event => { event.preventDefault(); setDragging(false); select(Array.from(event.dataTransfer.files)); }}
      style={{ border: `2px dashed ${dragging ? '#416E72' : '#B5B4AE'}`, borderRadius: 8, padding: 20 }}>
      <input ref={input} id={id} type="file" accept="image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf" multiple disabled={busy}
        onChange={event => { select(Array.from(event.target.files || [])); event.target.value = ''; }} style={{ maxWidth: '100%' }} />
      <p style={{ marginBottom: 0, color: '#585752', fontSize: 13 }}>Choose files or drag them here. JPG, PNG, or PDF; up to {maxFiles} files, {maxSizeMB} MB each.</p>
    </div>
    <ul style={{ padding: 0, listStyle: 'none' }} aria-live="polite">
      {files.map(file => <li key={file.id} style={{ padding: 12, marginTop: 8, borderRadius: 6, background: '#D9F0EE' }}>
        <div style={{ overflowWrap: 'anywhere' }}>{file.name} <small>({(file.size / 1024 / 1024).toFixed(1)} MB)</small></div>
        <div style={{ fontSize: 13, margin: '6px 0' }}>
          {file.status === 'uploaded' ? 'Saved with your application' : file.error || (busy && file.progress != null ? file.progress === 100 ? 'Verifying upload…' : 'Uploading…' : 'Upload incomplete. Choose this file again to retry, or remove it.')}
        </div>
        <button type="button" disabled={busy} onClick={() => onRemove(file)} aria-label={`Remove ${file.name}`}>Remove</button>
      </li>)}
    </ul>
    {(validationError || error) && <p role="alert" style={{ color: '#c53030' }}>{validationError || error}</p>}
  </div>;
}
